import type { PaginationDto } from '@api/domain/types';

export const DEFAULT_LIST_PAGINATION: PaginationDto = {
  pageNumber: 1,
  pageSize: 100,
  includeCount: true,
};
